// extracted by mini-css-extract-plugin
module.exports = {"root":"CouponBetsHistoryEmpty_root__4T6vG","icon":"CouponBetsHistoryEmpty_icon__nTE9Z","text":"CouponBetsHistoryEmpty_text__vkIaO"};